<template>
    <div class="btn-upload">
        <input v-show="false" type="file" id="file" ref="file" @change="handleFileUpload"/>
        <button type="button" class="btn btn-sm btn-blue btn-main btn-popup" :disabled="btnIsDisabled" @click="$refs.file.click()">
            {{$t("btnUpload")}}
        </button>
    </div>
</template>

<script>
    export default {
        data() {
          return {
              file: '',
              isDisabled: false
          }
        },
        methods: {
            handleFileUpload(){
                this.file = this.$refs.file.files[0];
                const allowedTypes = ["csv", "xlsx"];
                const type = this.file ? this.file.name.split(".").pop() : '';

                if(allowedTypes.includes(type)) {
                    this.uploadFile(this.file)
                    this.clearFieldFile()
                } else {
                    let error = this.$t('fileNotAllowed');
                    this.$store.dispatch('ADD_ALERT', {type: 'error', text: error})
                }
            },
            clearFieldFile() {
              this.file = this.$refs.file.value = '';
            },
            async uploadFile(file) {
                const fd = new FormData();
                fd.append("file", file);
                this.isDisabled = true
                this.$store.dispatch('uploadFile', fd).then(() => this.isDisabled = false)
            }
        },
        computed: {
            btnIsDisabled() {
                if(this.isDisabled) return true
            }
        }
    }
</script>
<style lang="sass" scoped>
    .btn-upload
        width: 100%
        display: flex

</style>